import styled from 'styled-components';
import { FormattedMessage } from 'react-intl';

export const CustomerDetailsTable = styled.div`
  display: grid;
  grid-column-gap: 15px;
  grid-template-columns: min-content minmax(min-content, 50px);
`;

export const CustomerDetailsLabel = styled.div`
  ${FormattedMessage} {
    white-space: nowrap;
    font-weight: bold;
  }
`;

export const CustomerDetailsCell = styled.div`
  white-space: nowrap;
`;
